
<div class="container">
    <div class="row justify-content-center">
        <div class="col">
            <div class="card">
                <div class="card-body">
                    <div class="text-primary text-center mb-2" style=" font-size:70px">
                        <i class="fa fa-info-circle" aria-hidden="true"></i>
                    </div>
                    <p>Your request has been received and we are working on configuring your Q2E instance to access Q2E GateCube, when we have completed this, you will receive an email to proceed to the next step.</p>
                </div>
            </div>
        </div>
    </div>
</div>